import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';

function ProductInvestmentDropdown({ onChangeDropdown, required, showTitle, selectedValue }) {
    const [selectedClientCompanyTypeOption, setSelectedClientCompanyTypeOption] = useState([]);
    const [getClientCompanyTypeOptions, setClientCompanyTypeOptions] = useState([]);

    // 🧠 Convert selectedValue (string or array) into number array
    const normalizeSelectedIds = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value.map(Number);
        if (typeof value === 'string') {
            return value
                .split(',')
                .map(v => parseInt(v.trim()))
                .filter(Boolean);
        }
        return [];
    };

    const fetchClientCompanyType = async () => {
        try {
            const response = await axios.get(getApiBaseUrl() + "/clientCompanyTypelist", {
                params: { UserId: getStorageValues('userId') }
            });
            if (response.status === 200) {
                const cct = response.data.data[0];
                const options = cct.map(p => ({
                    value: p.ClientCompanyTypeId,
                    label: p.ClientCompanyTypeName,
                }));
                setClientCompanyTypeOptions(options);
            }
        } catch (error) {
            console.error("Error fetching company types:", error);
        }
    };

    // 🟢 Fetch data on mount
    useEffect(() => {
        fetchClientCompanyType();
    }, []);

    // 🟢 Update selected options once both data & selectedValue are available
    useEffect(() => {
        if (getClientCompanyTypeOptions.length > 0 && selectedValue) {
            const selectedIds = normalizeSelectedIds(selectedValue);
            const matchedOptions = getClientCompanyTypeOptions.filter(opt =>
                selectedIds.includes(opt.value)
            );
            setSelectedClientCompanyTypeOption(matchedOptions);
        }
    }, [getClientCompanyTypeOptions, selectedValue]);

    const handleChange = (selectedOptions) => {
        setSelectedClientCompanyTypeOption(selectedOptions || []);
        const ids = (selectedOptions || []).map(opt => opt.value);
        onChangeDropdown(ids); // send numeric IDs only
    };

    return (
        <div>
            {showTitle && (
                <label className="form-label">
                    Client Company Type {required && <span style={{ color: "red" }}>*</span>}
                </label>
            )}
            <Select
                name="ClientCompanyTypeIds"
                value={selectedClientCompanyTypeOption}
                isClearable
                isMulti
                options={getClientCompanyTypeOptions}
                onChange={handleChange}
                closeMenuOnSelect={false}
            />
        </div>
    );
}

export default ProductInvestmentDropdown;
